export default __webpack_public_path__ + "static/sellars-550570a857d5c1370b2730950ca79ec2.jpg";